import { TimeslotsTool } from 'features/hallmapToolbar';
import { SlotsContainer } from './styles';
import { DatePicker } from 'features/hallmapToolbar/datePicker';
import { CurrentTimeSwitch } from 'features/hallmapToolbar/currentTimeSwitch';
import { useAppDispatch, useAppSelector } from 'shared/lib/store';
import { selectSelectedTimeslot, useTimeslot, useTimeslotZone } from 'entities/toolbar/timeslots';
import { useGetSlotsByDate } from 'features/hallmapToolbar/datePicker/lib/useGetSlotsByDate';
import { useDebounceCallback } from 'shared/lib/debounce';
import { useEffect, useState } from 'react';
import { setToBookingButtonDisabled } from 'entities/orders/model/ordersSlice';

export const TimeLine = () => {
	const selectedTimeslot = useAppSelector(selectSelectedTimeslot);
	const { getSlotsByDate } = useGetSlotsByDate();
	const { formatISODateBySlotZone } = useTimeslotZone();
	const { toTimeslot } = useTimeslot();
  const dispatch = useAppDispatch();

  const [ visibleDate, setVisibleDate ] = useState<Date>(selectedTimeslot ? new Date(selectedTimeslot) : new Date());

	const onDateChange = async (date: Date) => {
		if (!date) {
			return;
		}

		const newTimeslotDate = new Date(selectedTimeslot);
		newTimeslotDate.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
    setVisibleDate(date);
    dispatch(setToBookingButtonDisabled(true));
    onDateChangeDebounced(date, newTimeslotDate);
	}

  const onDateChangeDebounced = useDebounceCallback(async (date, newTimeslotDate) => {
		toTimeslot(formatISODateBySlotZone(newTimeslotDate), { clear: true })
		await getSlotsByDate(date);
    setTimeout(() => {
      dispatch(setToBookingButtonDisabled(false));
    }, 300);
  }, 500);

  useEffect(() => {
    setVisibleDate(selectedTimeslot ? new Date(selectedTimeslot) : new Date());
  }, [selectedTimeslot])

	return (
		<SlotsContainer>
			<DatePicker onChange={onDateChange} value={visibleDate} />
			<CurrentTimeSwitch />
			<TimeslotsTool />
		</SlotsContainer>
	);
}
